import StaticTextFormAttribute from '/app/javascript/bundles/KeenformRenderer/components/formelements/StaticTextFormAttribute/StaticTextFormAttribute';

export default class StaticTextFormAttributeEditor extends StaticTextFormAttribute{
  createMarkup(){
    return {__html: this.props.value};
  }
}
